var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "document--tasks_2_",
    "data-name": "document--tasks (2)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26889",
    "data-name": "Path 26889",
    d: "M20.25,24.3,18.793,22.84,18,23.633l2.25,2.25,4.5-4.5-.793-.793Z",
    transform: "translate(-7.875 -9.008)",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26890",
    "data-name": "Path 26890",
    d: "M11.063,16.625H7.125V3.125h4.5V6.5A1.128,1.128,0,0,0,12.75,7.625h3.375V11H17.25V6.5a.511.511,0,0,0-.169-.394L13.144,2.169A.511.511,0,0,0,12.75,2H7.125A1.128,1.128,0,0,0,6,3.125v13.5A1.128,1.128,0,0,0,7.125,17.75h3.938ZM12.75,3.35,15.9,6.5H12.75Z",
    transform: "translate(-2.625 -0.875)",
    fill: "#101010"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    width: 18,
    height: 18,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.54ba840cf67c3411475f5d48f1d4a13f.svg";
export { ForwardRef as ReactComponent };